var Modernizr = require('modernizr');

var CSSPlugin = require('gsap/CSSPlugin');
var TweenLite = require('gsap/TweenLite');

var T = TweenLite.to($('.products-grid__detailed-view'), 1, {
  minHeight: 0,
  height: 0,
  flex: 'none'
}).reversed(true);

// $('header').click(function(){ T.reversed(!T.reversed()) });

var s;
var Grid = {
  settings: {
    breakpoints: {
      '768px': 2,
      '992px': 3,
      normal: 5
    },
    gridItem: '.products-grid__item',
    gridItemDetailedView: '.products-grid__detailed-view'
    // $gridItemDetailedView: $(".products-grid__detailed-view"),
  },

  init: function(element) {
    s = this.settings;
    this.bindUIElements();
    $(element).addClass('initialised');
  },

  bindUIElements: function() {
    var that = this;
    $(s.gridItem).on('click', function(e) {
      // if (!Modernizr.mq('(max-width: 991px)')) {
      //     e.preventDefault();
      //     var href = $(this).attr('href');
      //     that.toggleRow($(this).index(s.gridItem), href);
      // }
    });

    $(window).on('resize', that.removeDetailedView);
  },

  generateRow: function(href) {
    return new Promise(function(resolve, reject) {
      var html = '';
      html += '<div class="' + s.gridItemDetailedView.split('.').join('') + '">';
      html += '<div class="products-grid__detailed-view__wrapper">';

      $.ajax({
        url: href,
        data: {
          ajax: true
        },
        contentType: 'application/json',

        success: function(data) {
          html += data;
          html += '</div>';
          html += '</div>';

          resolve(html);
        },
        error: function() {
          html += 'An error ocurred.';
          html += '</div>';
          html += '</div>';

          reject(html);
        }
      });
    });
  },

  toggleRow: function(elementNumber, href) {
    var that = this;

    this.removeDetailedView().then(function() {
      that.insertDetailedView(elementNumber, href);
    });
  },

  getRowNumber: function(elementNumber) {
    var numberOfColumns;
    if (Modernizr.mq('(max-width: 767px)')) {
      numberOfColumns = 2;
      // console.log("768px");
    } else if (Modernizr.mq('(min-width: 768px)') && Modernizr.mq('(max-width: 992px)')) {
      numberOfColumns = 3;
      // console.log("768px && 992px");
    } else {
      numberOfColumns = 5;
      // console.log("greater");
    }

    return Math.floor(elementNumber / numberOfColumns) * numberOfColumns + numberOfColumns - 1;
  },

  removeDetailedView: function() {
    return new Promise(function(resolve, reject) {
      var callbackComplete = function() {
        // alert('go');
        $(s.gridItemDetailedView).remove();
        resolve();
      };

      if ($(s.gridItemDetailedView).length > 0) {
        TweenLite.to(s.gridItemDetailedView, 0.4, {
          height: 0,
          onComplete: callbackComplete
        });
        // $(s.gridItemDetailedView).remove();
      } else {
        resolve();
      }
    });
  },

  insertDetailedView: function(elementNumber, href) {
    var that = this;
    var elementRowNumber = this.getRowNumber(elementNumber);

    var insertAfterEl;

    that.generateRow(href).then(function(data) {
      $(data).insertAfter($(s.gridItem).eq(elementRowNumber));
      TweenLite.from(s.gridItemDetailedView, 0.5, {
        height: 0,
        minHeight: 0,
        flex: '0 0 100%',
        onStart: that.updateProductData,
        onStartParams: [that, elementRowNumber]
      });
    });
  },

  updateProductData: function(that, elementRowNumber) {
    // this
  },

  getProductData: function() {}
};

module.exports = Grid;



// WEBPACK FOOTER //
// ./public/src/js/ProductGrid.js